import GifSlide from './GifSlide';

export default GifSlide;
